import whatsAppIcon from '../assets/images/whatsapp-icon.svg';
import copyIcon from '../assets/images/copy-icon.svg';
import emailIcon from '../assets/images/email-icon.svg';
import outlookIcon from '../assets/images/outlook-icon.svg';
import PropTypes from 'prop-types';
import { copyToClipboard } from '../utils/utils';
import { isDesktop } from 'react-device-detect';
import { useDispatch } from 'react-redux';
import { handleToast } from '../redux/Slice/toastSlice';

const ShareIcons = ({ bodyText, subjectText, setHasShared, copyToastText }) => {
  const dispatch = useDispatch();

  const markAsShared = () => {
    if (!setHasShared) return;
    setHasShared(true);
  }

  const onCopyLink = () => {
    copyToClipboard(bodyText);
    markAsShared();
    dispatch(handleToast({
      open: true,
      type: 'success',
      text: copyToastText
    }))
  };
  const encodedText = encodeURIComponent(bodyText);
  const encodedSubject = encodeURIComponent(subjectText);

  const onShareWhatsApp = () => {
    const whatsappUrl = `https://api.whatsapp.com/send?text=${encodedText}`;
    window.open(whatsappUrl, '_blank');
    markAsShared();
  };

  const onShareEmail = () => {
    const emailUrl = `mailto:?subject=${encodedSubject}&body=${encodedText}`;
    const a = document.createElement('a');
    a.href = emailUrl;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    markAsShared();
  };

  const onShareGmail = () => {
    const gmailUrl = `https://mail.google.com/mail/u/0/?view=cm&fs=1&su=${encodedSubject}&body=${encodedText}`;
    window.open(gmailUrl, '_blank');
    markAsShared();
  };

  const onShareOutlook = () => {
    const outlookUrl = `https://outlook.office.com/mail/deeplink/compose?subject=${subjectText}&body=${encodedText}`;
    window.open(outlookUrl, '_blank');
    markAsShared();
  };

  return (
    <div className={'icons-share-container'}>
      <img src={whatsAppIcon} alt='whatsapp' onClick={onShareWhatsApp} />
      {isDesktop
        ? <img src={emailIcon} alt='gmail' onClick={onShareGmail} />
        : <img src={emailIcon} alt='email' onClick={onShareEmail} />
      }
      <img src={copyIcon} alt='copiar' onClick={onCopyLink} />
      {isDesktop && <img src={outlookIcon} alt='outlook' onClick={onShareOutlook} />}
    </div>
  );
};

export default ShareIcons;

ShareIcons.propTypes = {
  bodyText: PropTypes.string.isRequired,
  subjectText: PropTypes.string.isRequired,
  setHasShared: PropTypes.func,
  copyToastText: PropTypes.string.isRequired,
};
